import { Pagination, PaginationProps } from 'antd';

const AppPagination = ({ ...props }: PaginationProps) => {
  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement,
  ) => {
    if (type === 'prev') {
      return (
        <a
          className="mr-3"
          style={{
            fontSize: 12,
          }}
        >
          Previous
        </a>
      );
    }
    if (type === 'next') {
      return (
        <a
          className=" ml-3"
          style={{
            fontSize: 12,
          }}
        >
          Next
        </a>
      );
    }

    return originalElement;
  };
  return <Pagination itemRender={itemRender} {...props} />;
};

export default AppPagination;
